export const enum DetailsTab {
  None = 'none',
  CustomerDetails = 'customer-details',
  AddApplication = 'add-application',
}
